// extracted by mini-css-extract-plugin
export default {"form":"import-data_form__Ut5B-","mainBtnDiv":"import-data_mainBtnDiv__nW7iv"};